import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide28Botschaft3(_: SlideProps) {
  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Botschaft 03</div>
        <h1 className="deck-title rise rise-2">
          Ihr <br />
          <span className="accent">gestaltet mit</span>
        </h1>
      </header>

      <div className="deck-big">
        <div className="big-statement rise rise-4">
          Eure Erfahrung bestimmt, welche Prozesse wir{" "}
          <span className="accent">als Nächstes automatisieren.</span>
        </div>
      </div>
    </div>
  );
}
